import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid, Alert, Typography } from "@mui/material"
import { Campus, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, RadioButton } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { campaigns, consent, consentement, defaultValues, getCampus, salutations, specialities } from "services"
import { useEffect, useState } from "react"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const [isFormSent, setIsFormSent] = useState(false)
  
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('NewsletterRegistration') === 'true') {
      setIsFormSent(true)
    }
  }, [])

  const productId = 'ESME_NL'
  const { submission } = useSubmission()
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      formations: [],
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        Apprentissage__c: false,
        OptIn_Email__c: true,
        Bachelor__c: false,
        CycleInge__c: false,
        Master__c: false,
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, setValue } = methods
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const campus = lead.Campus__c
    const defaultDataLead = {
      Division__c: 'ESME',
      IONISSchool__c: 'ESME',
      LeadSource: 'Inscription Newsletter',
      RecordTypeId: recordTypeId
    }
    const finalLead = { ...lead, ...defaultDataLead }
    try {
      // const leadCreated = await salesforce.createLead(finalLead)
      // const campaignMember = {
      //   CampaignId: campaignId,
      //   LeadId: leadCreated.Id,
      //   Status: 'Active'
      // }
      // await salesforce.createCampaignMember(campaignMember)
      await submission({
        formId: 'NEWSLETTER',
        lead: finalLead,
        campaignId: campaignId,
        campaignStatus: 'Active',
        utmCookieName: '_ionis_user_data' // optionnel
      })
      const url = new URL(window.location.href)
      url.searchParams.set('NewsletterRegistration', 'true')
      window.location.href = url.toString()
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  useEffect(() => {
    if (salesforce !== null && productId !== undefined) {
      const getData = async () => {
        const campaign = await salesforce.getCampaign(productId)
        return { campaign }
      }
      getData().then((value) => {
        const { campaign } = value
        setValue('campaignId', campaign.Id)
        // setOpenBackdrop(false)
      }).catch((error) => {
        setError('Une erreur est survenue lors du chargement du formulaire', error)
      })
    }
  }, [salesforce, productId, setError, setValue])
  // Watch
  // useEffect
  useSalesforce('EngineeringSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      {isFormSent ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Alert severity="success">
              <Typography variant="h6" gutterBottom>
                Merci pour votre inscription à notre newsletter.
              </Typography>
              <Typography>
                Votre demande a bien été prise en compte.
              </Typography>
            </Alert>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <InputText control={control} label="Prénom" name="lead.FirstName" required />
          </Grid>
          <Grid item sm={6} xs={12}>
            <InputText control={control} label="Nom" name="lead.LastName" required />
          </Grid>
          <Grid item sm={8} xs={12}>
            <Email control={control} label="Adresse e-mail" name="lead.Email" required />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Campus label="Campus souhaité" options={getCampus('ESME_EVENT')} />
          </Grid>
          <ConsentementMultiple optinNL={true} />
          <RequiredFields />
          <Submit onSubmit={onSubmit} />
          <MentionsLegales form="JDMI" school="ESME" />
        </Grid>
      )}
    </FormProvider>
  )
}

export default Form
